import { Box, BoxProps, Stack } from '@mantine/core'
import useStyles from './index.styles'
import { SectionWrapperProps } from '..'
import { useMemo } from 'react'

export type SectionWrapperBoxProps = {
  noPadding?: boolean
} & SectionWrapperProps &
  BoxProps

export const Wrapper = ({
  title,
  titleAs,
  description,
  icon,
  children,
  bgColor: bgColorProp,
  className,
  classNames,
  layout,
  styles,
  innerClass = 'hhg-page-container',
  noPadding,
  defaultColor = 'transparent',
  ...rest
}: SectionWrapperBoxProps) => {
  const bgColor = useMemo(() => bgColorProp || defaultColor, [])
  const hasColor =
    ['', '#fff', '#fff', 'transparent'].filter(
      (i) => i === bgColor.toLowerCase(),
    ).length === 0
  const { classes, cx } = useStyles(
    { bgColor: bgColor, noPadding, hasColor },
    {
      name: 'ServiceConnections__SectionWrapper-Wrapper',
      styles,
      classNames,
    },
  )

  return (
    <Box
      className={cx(classes.root, className)}
      data-has-color={hasColor}
      {...(hasColor && {
        'data-color': bgColor,
      })}
      {...rest}
    >
      <Stack className={cx(innerClass, classes.innerClass)}>{children}</Stack>
    </Box>
  )
}
